import {observer} from "mobx-react-lite";
import {globalStore} from "../../global.store";
import Modalcontainer from "../modalcontainer";
import { Notification } from '../modalcontainer/bodyContent/notification';

const NotificationPopup = observer(() => {
    const {
        notificationContent,
    } = globalStore;
    return (
        <Modalcontainer
            backBtn={false}
            closePopup={notificationContent.action as Function}
            canClose={false}
        >
            <Notification
                button={notificationContent.button}
                headerText={notificationContent.headerText}
                action={notificationContent.action}
                time={notificationContent.time}
            />
        </Modalcontainer>
    )
})

export default NotificationPopup;